// extracted by mini-css-extract-plugin
export default {"begin-draft-button":"styles_begin-draft-button__zy25A"};